"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const native_1 = require("@react-navigation/native");
const moment_1 = __importDefault(require("moment"));
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const slice_2 = require("../../../app-reduxs/articleCreating/slice");
const slice_3 = require("../../../app-reduxs/articleLike/slice");
const icons_1 = require("../../../assets/icons");
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const IconComment_1 = __importDefault(require("../../../assets/icons/IconComment"));
const IconLike_1 = __importDefault(require("../../../assets/icons/IconLike"));
const IconLiked_1 = __importDefault(require("../../../assets/icons/IconLiked"));
const images_1 = require("../../../assets/images");
const components_1 = require("../../../components");
const IconThreeDoc_1 = __importDefault(require("../../../components/Icon/IconThreeDoc"));
const ModalConfirmDeleteArticle_1 = __importDefault(require("../../../components/modal/ModalConfirmDeleteArticle"));
const skeletons_1 = require("../../../components/skeletons");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const tooltips_1 = require("../../../components/tooltips");
const constants_1 = require("../../../constants");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Article_1 = __importDefault(require("../../../networking/apis/Article"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const components_2 = require("./components");
const styles_1 = __importDefault(require("./styles"));
const DetailStoryScreen = (props) => {
    const { id } = props.route.params;
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigation = (0, native_1.useNavigation)();
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [article, setArticle] = (0, react_1.useState)();
    const [headers, setHeaders] = (0, react_1.useState)();
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [likes, setLikes] = (0, react_1.useState)(0);
    const [isLiked, setLiked] = (0, react_1.useState)(false);
    const [limitModalVisible, setLimitModalVisible] = (0, react_1.useState)(false);
    const refScrollView = (0, react_1.createRef)();
    const refIsCallingApi = (0, react_1.useRef)(false);
    const isArticle = article?.content_type == 1;
    const isAnonymous = myProfile?.registration_status == 0;
    (0, react_1.useEffect)(() => {
        if (!!article) {
            const imgs = document.querySelectorAll('.editView img');
            imgs.forEach((img) => {
                img.addEventListener('click', () => {
                    const src = img.src;
                    (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, { uri: src });
                });
            });
            return () => {
                imgs.forEach(img => {
                    img.removeEventListener('click', () => { });
                });
            };
        }
    }, [article]);
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        if (connected) {
            getArticleDetail();
        }
    }, [connected, id]));
    const getArticleDetail = () => {
        if (refIsCallingApi.current)
            return;
        refIsCallingApi.current = true;
        refScrollView.current?.scrollTo({ x: 0, y: 0, animated: true });
        Article_1.default.getArticleDetail(id)
            .then((response) => {
            setHeaders(response.headers);
            setArticle(response.data.data);
            setLikes(response.data.data.likes);
            setLiked(!!response.data.data.is_liked);
        })
            .catch((err) => {
            if (err?.response?.data?.error?.code == 'BUSINESS_RULE_VIOLATION') {
                // dispatch(appSlice.actions.setToastType(false));
                // dispatch(appSlice.actions.showToast(err?.response?.data?.error?.message))
                setLimitModalVisible(true);
            }
        })
            .finally(() => {
            setLoading(false);
            refIsCallingApi.current = false;
        });
    };
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: article?.user_handle,
            },
        });
    };
    const onToggleLikeButton = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        if (refIsCallingApi.current)
            return;
        refIsCallingApi.current = true;
        (isLiked ?
            Article_1.default.unlikeArticle(article?.article_id)
            :
                Article_1.default.likeArticle(article?.article_id))
            .then((_) => {
            setLikes(!isLiked ? likes + 1 : likes - 1);
            setLiked(!isLiked);
            dispatch((0, slice_3.addArticleToggleLikeAction)({ article_id: article?.article_id, isLike: !isLiked }));
        })
            .catch((_) => { })
            .finally(() => {
            refIsCallingApi.current = false;
        });
    };
    const handleNavigateToComment = () => {
        if (isAnonymous) {
            return dispatch(slice_1.default.actions.showRequestLoginModal());
        }
        (0, rootNavigation_1.navigate)(Routes_1.default.REP_COMMENT_ARTICLE, { article: id, type: 'POST' });
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    if (article?.is_blocked == 1)
        return react_1.default.createElement(components_2.BlockedView, { article: article, onUnblock: getArticleDetail });
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: article?.title || ' ', styleContainer: {
                backgroundColor: 'white',
                marginBottom: 0,
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#292A33' }), onLeftPress: navigation.goBack }),
        react_1.default.createElement(react_native_1.ScrollView, { ref: refScrollView, style: styles_1.default.body, contentContainerStyle: {
                paddingBottom: (0, scale_1.scale)(68 + 36 + 8),
            }, pointerEvents: article ? 'auto' : 'none', showsVerticalScrollIndicator: false },
            react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                    if (!!article?.thumbnail_url) {
                        (0, rootNavigation_1.navigate)(Routes_1.default.IMAGE_VIEWER_SCREEN, { uri: article?.thumbnail_url });
                    }
                } },
                react_1.default.createElement(react_native_1.Image, { source: article?.thumbnail_url ? { uri: article.thumbnail_url } : images_1.images.NoImages, style: styles_1.default.articleImage, resizeMode: "cover" })),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.articleInfo },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.articleTitle }, article?.title),
                react_1.default.createElement(components_1.HashtagCollapsible, { hashtags: article?.hash_tags || [], defaultLine: 2, containerStyle: { marginTop: (0, scale_1.scale)(8) }, type: isArticle }),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.authorInfo },
                    react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                        react_1.default.createElement(react_native_1.Image, { resizeMode: "cover", source: article?.user_thumbnail_url
                                ? { uri: article?.user_thumbnail_url }
                                : images_1.images.AvatarDefaul, style: styles_1.default.authorAvatar })),
                    react_1.default.createElement(react_native_1.View, { style: { justifyContent: 'center' } },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.authorName, onPress: navigateToUserProfile }, article?.user_nickname || constants_1.DEFAULT_NAME),
                        react_1.default.createElement(react_native_1.View, { style: { marginTop: (0, scale_1.scale)(4) } },
                            react_1.default.createElement(tooltips_1.DateTimeTooltip, { title: (0, moment_1.default)(article?.posting_datetime).format('YYYY/MM/DD HH:mm') }, `${(0, helpler_1.stringToDateFormat)(article?.posting_datetime)} `)))),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.articleStatus },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.articleStatusLeft },
                        react_1.default.createElement(react_native_1.Pressable, { onPress: () => {
                                (0, rootNavigation_1.navigate)(Routes_1.default.LIST_COMMENT_ARTICLE, {
                                    articleId: id,
                                });
                            } },
                            react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.statusNumber },
                                (0, helpler_1.formatNumber)(article?.comments || 0),
                                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.statusUnit }, "\u4EF6\u306E\u30B3\u30E1\u30F3\u30C8"))),
                        react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.statusNumber },
                            (0, helpler_1.formatNumber)(likes),
                            react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.statusUnit }, "\u4EF6\u306E\u3044\u3044\u306D"))),
                    react_1.default.createElement(IconThreeDoc_1.default, { data: article, uri: `${window.location.origin}/article/detail-story/${id}`, displayTweet: rootNavigation_1.goBack }))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.statusRow },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: styles_1.default.commentButton, onPress: handleNavigateToComment },
                    react_1.default.createElement(IconComment_1.default, { width: (0, scale_1.scale)(28), height: (0, scale_1.scale)(28), color: '#545454' })),
                react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: onToggleLikeButton }, isLiked ? (react_1.default.createElement(IconLiked_1.default, { width: (0, scale_1.scale)(28), height: (0, scale_1.scale)(28) })) : (react_1.default.createElement(IconLike_1.default, { width: (0, scale_1.scale)(28), height: (0, scale_1.scale)(28), color: '#545454' })))),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.articleContent },
                react_1.default.createElement("style", null, `
							.editView p {
								margin: 0;
								padding: 0;
							}
							.ql-editor {
								padding: 0px 0px;
								overflow: hidden;
							}
							.editView::-webkit-scrollbar {
								display: none;
							}
							.editView {
								-ms-overflow-style: none;  /* IE and Edge */
								scrollbar-width: none;  /* Firefox */
							}
						`),
                react_1.default.createElement("div", { className: "ql-snow" },
                    react_1.default.createElement("div", { className: "ql-editor editView", dangerouslySetInnerHTML: { __html: article?.full_text || '' } }))),
            !!article?.inherited_from_user_id && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.rootArticle },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.rootArticleTitle }, isArticle
                    ? '継承元の記事を作成した先輩'
                    : '継承元の自分史を作成した先輩'),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.rootArticleBody },
                    react_1.default.createElement(react_native_1.Pressable, { style: { flex: 1, flexDirection: 'row', alignItems: 'center' }, onPress: () => {
                            if (article.inherited_from_article_id) {
                                (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, {
                                    id: article.inherited_from_article_id,
                                });
                            }
                            else {
                                (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                    screen: Routes_1.default.USER_PROFILE,
                                    params: {
                                        userHandle: article?.inherited_from_user_handle,
                                    },
                                });
                            }
                        } },
                        react_1.default.createElement(react_native_1.Image, { resizeMode: "cover", source: article.inherited_from_user_thumbnail_url
                                ? { uri: article.inherited_from_user_thumbnail_url }
                                : images_1.images.AvatarDefaul, style: styles_1.default.authorAvatar }),
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.rootArticleInfo },
                            react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 1, style: styles_1.default.rootArticleAuthorName }, article.inherited_from_user_nickname || constants_1.DEFAULT_NAME),
                            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles_1.default.rootArticleAuthorId },
                                "@",
                                article.inherited_from_user_handle))),
                    react_1.default.createElement(components_1.FollowButton, { userId: article.inherited_from_user_id, nickname: article.inherited_from_user_nickname || constants_1.DEFAULT_NAME, defaultValue: article.inherited_from_user_is_followed == '1', customStyle: styles_1.default.rootArticleButton })))),
            !!article?.inherited_article?.length && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.inheritArticles },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.rootArticleTitle }, isArticle
                    ? 'この記事から継承された記事'
                    : 'この自分史から継承された自分史'),
                article.inherited_article.map((_article, index) => (react_1.default.createElement(react_native_1.Pressable, { key: index, style: styles_1.default.inheritArticleItem, onPress: () => {
                        (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, {
                            id: _article.article_id,
                        });
                    } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.row },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.inheritArticleItemLeft },
                            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, weight: "600", style: styles_1.default.inheritArticleItemTitle }, _article.title),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.hashTagList }, _article.hash_tags?.map((item, index) => (react_1.default.createElement(components_1.HashtagText, { key: index, text: item.name, style: styles_1.default.inheritArticleHashtag, onPress: () => {
                                    (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                        screen: Routes_1.default.HASHTAG_DETAIL,
                                        params: {
                                            hashtag: item.name,
                                            typeScreen: 0,
                                            typeHashTag: isArticle ? 1 : 2,
                                        },
                                    });
                                } })))),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    styles_1.default.row,
                                    { marginTop: (0, scale_1.scale)(8), alignItems: 'center' },
                                ] },
                                react_1.default.createElement(react_native_1.Image, { source: _article.user_thumbnail_url
                                        ? {
                                            uri: _article.user_thumbnail_url,
                                        }
                                        : images_1.images.AvatarDefaul, resizeMode: "cover", style: styles_1.default.inheritArticleItemAuthorAvatar }),
                                react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles_1.default.inheritArticleItemAuthor }, _article.user_nickname || constants_1.DEFAULT_NAME))),
                        !!_article.thumbnail_url && (react_1.default.createElement(react_native_1.Image, { source: { uri: _article.thumbnail_url }, resizeMode: "cover", style: styles_1.default.inheritArticleItemImage })))))),
                !!article?.count_inherited_article && (react_1.default.createElement(CustomText_1.default, { style: styles_1.default.inheritArticleItemNote },
                    "\u3053\u306E",
                    article.content_type == 1 ? '記事' : '自分史',
                    "\u304B\u3089",
                    article?.count_inherited_article,
                    "\u4EF6\u4EE5\u4E0A\u306E",
                    article.content_type == 1 ? '記事' : '自分史',
                    "\u304C\u4F5C\u6210\u3055\u308C\u3066\u3044\u307E\u3059")))),
            article?.status != 0 && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.inheritArticles },
                react_1.default.createElement(react_native_1.View, { style: [styles_1.default.row, { justifyContent: 'space-between', width: (0, scale_1.scale)(343) }] },
                    react_1.default.createElement(components_1.BorderButton, { title: "\u7D99\u627F\u30DE\u30C3\u30D7\u3092\u898B\u308B", style: styles_1.default.inheritArticleButton, onPress: () => {
                            if (isAnonymous) {
                                return dispatch(slice_1.default.actions.showRequestLoginModal());
                            }
                            (0, rootNavigation_1.navigate)(Routes_1.default.MIND_MAP_SCREEN, {
                                nodeId: article?.article_id,
                            });
                        } }),
                    react_1.default.createElement(components_1.LinearButton, { title: isArticle ? '継承して記事を作成' : '継承して自分史を作成', style: [
                            styles_1.default.inheritArticleButton,
                            { borderWidth: 0, marginLeft: (0, scale_1.scale)(12) },
                        ], textStyle: styles_1.default.inheritArticleButtonLabel, onPress: async () => {
                            if (isAnonymous) {
                                return dispatch(slice_1.default.actions.showRequestLoginModal());
                            }
                            if (!!article) {
                                if (refIsCallingApi.current)
                                    return;
                                refIsCallingApi.current = true;
                                const form = new FormData();
                                form.append('inherited_from_article_id', article.article_id);
                                Article_1.default.getArticlePreview(form)
                                    .then(response => {
                                    const articlePreview = response.data;
                                    dispatch((0, slice_2.createArticleAction)({
                                        title: article.title || '',
                                        full_text: article.full_text || '',
                                        thumbnail_image: article.thumbnail_url || '',
                                        content_type: article?.content_type,
                                        inherited_from_article_id: article.article_id || '',
                                        inherited_from_user_id: articlePreview?.inherited_user_id,
                                        inherited_from_user_nickname: articlePreview?.nickname || '',
                                        inherited_from_user_handle: articlePreview?.user_handle,
                                        inherited_from_user_thumbnail: articlePreview?.thumbnail_url || '',
                                    }));
                                    if (article.hash_tags.length > 0) {
                                        const hashtags = article.hash_tags.map((it) => it.name);
                                        dispatch((0, slice_2.addHashtagsAction)(hashtags));
                                    }
                                    (0, rootNavigation_1.navigate)(Routes_1.default.CREATE_ARTICLE);
                                })
                                    .catch(() => { })
                                    .finally(() => refIsCallingApi.current = false);
                            }
                        } })))),
            !!article?.hashtag_related_articles.length &&
                article?.hashtag_related_articles.length > 0 && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.relativeHashtag },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.rootArticleTitle },
                    "\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u95A2\u9023\u306E",
                    isArticle ? '記事' : '自分史'),
                article.hashtag_related_articles.map((item, index) => item.is_deleted == 1 ? (react_1.default.createElement(react_native_1.View, { key: index, style: styles_1.default.relativeHashtagBody },
                    react_1.default.createElement(CustomText_1.default, { style: styles_1.default.relativeHashtagText },
                        "\u6295\u7A3F\u8005\u306B\u3088\u3063\u3066\u524A\u9664\u3055\u308C\u305F",
                        isArticle ? '記事' : '自分史',
                        "\u3067\u3059"))) : (react_1.default.createElement(react_native_1.Pressable, { style: styles_1.default.inheritArticleItem, key: index, onPress: () => {
                        (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, { id: item.article_id });
                    } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.row },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.inheritArticleItemLeft },
                            react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, weight: "600", style: styles_1.default.inheritArticleItemTitle }, item.title),
                            react_1.default.createElement(react_native_1.View, { style: styles_1.default.hashTagList }, item.hash_tags.map((it, idx) => (react_1.default.createElement(components_1.HashtagText, { key: idx, text: it.name, style: styles_1.default.inheritArticleHashtag, onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                    screen: Routes_1.default.HASHTAG_DETAIL,
                                    params: {
                                        hashtag: it.name,
                                        typeScreen: 0,
                                        typeHashTag: isArticle
                                            ? 1
                                            : 2,
                                    },
                                }) })))),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    styles_1.default.row,
                                    {
                                        marginTop: (0, scale_1.scale)(8),
                                        alignItems: 'center',
                                    },
                                ] },
                                react_1.default.createElement(react_native_1.Image, { source: !!item.user_thumbnail_url
                                        ? { uri: item.user_thumbnail_url }
                                        : images_1.images.AvatarDefaul, resizeMode: "cover", style: styles_1.default.inheritArticleItemAuthorAvatar }),
                                react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: styles_1.default.inheritArticleItemAuthor }, item.user_nickname || constants_1.DEFAULT_NAME))),
                        !!item.thumbnail_url && (react_1.default.createElement(react_native_1.Image, { source: { uri: item.thumbnail_url }, resizeMode: "cover", style: styles_1.default.inheritArticleItemImage })))))))),
            !!article?.recommends.length && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.suggestArticles },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.rootArticleTitle },
                    "\u3053\u306E\u5148\u8F29\u306E\u304A\u3059\u3059\u3081",
                    isArticle ? '記事' : '自分史'),
                article?.recommends.map((item, index) => (react_1.default.createElement(react_native_1.TouchableOpacity, { key: index, style: styles_1.default.suggestArticleItem, onPress: () => (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, { id: item.article_id }) },
                    react_1.default.createElement(react_native_1.View, { style: { flex: 1, marginRight: (0, scale_1.scale)(12) } },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 2, style: styles_1.default.suggestArticleItemTitle }, item.title),
                        react_1.default.createElement(react_native_1.View, { style: [
                                styles_1.default.row,
                                { marginTop: (0, scale_1.scale)(8), alignItems: 'center' },
                            ] },
                            react_1.default.createElement(IconComment_1.default, { width: (0, scale_1.scale)(18), height: (0, scale_1.scale)(18), color: '#545454' }),
                            react_1.default.createElement(CustomText_1.default, { style: styles_1.default.suggestArticleItemComment }, (0, helpler_1.formatNumber)(item.comments)))),
                    react_1.default.createElement(react_native_1.Image, { source: item.thumbnail_url
                            ? { uri: item.thumbnail_url }
                            : images_1.images.NoImages, resizeMode: "cover", style: styles_1.default.suggestArticleItemImage })))))),
            (!!headers?.['x-next-article-id'] || !!headers?.['x-previous-article-id']) && (react_1.default.createElement(react_native_1.View, { style: styles_1.default.navigateOtherArticle },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: [
                        styles_1.default.navigateButton,
                        !headers['x-previous-article-id'] && { opacity: 0 },
                    ], disabled: !headers['x-previous-article-id'], onPress: () => {
                        (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, { id: headers['x-previous-article-id'] });
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: styles_1.default.navigateButtonLabel },
                        "\u524D\u306E",
                        isArticle ? '記事' : '自分史'),
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.navigateButtonRow },
                        react_1.default.createElement(icons_1.IC_ARROW_LEFT, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20) }),
                        react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 2, style: styles_1.default.navigateArticleLabel }, decodeURIComponent(headers['x-previous-article-title']).replace(/\+/g, ' ')))),
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.navigateArticleDecor }),
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: [
                        styles_1.default.navigateButton,
                        !headers['x-next-article-id'] && { opacity: 0 },
                    ], disabled: !headers['x-next-article-id'], onPress: () => {
                        (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, { id: headers['x-next-article-id'] });
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "600", style: [styles_1.default.navigateButtonLabel, { textAlign: 'right' }] },
                        "\u6B21\u306E",
                        isArticle ? '記事' : '自分史'),
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.navigateButtonRow },
                        react_1.default.createElement(CustomText_1.default, { weight: "600", numberOfLines: 2, style: [
                                styles_1.default.navigateArticleLabel,
                                {
                                    textAlign: 'right',
                                    marginLeft: 0,
                                    marginRight: (0, scale_1.scale)(10),
                                },
                            ] }, decodeURIComponent(headers['x-next-article-title']).replace(/\+/g, ' ')),
                        react_1.default.createElement(icons_1.IC_ARROW_RIGHT, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20) })))))),
        !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.Pressable, { style: [
                    styles_1.default.bottomButtonItem,
                    { right: (0, scale_1.scale)(72), bottom: (0, scale_1.scale)(68) },
                ], onPress: handleNavigateToComment },
                react_1.default.createElement(IconComment_1.default, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20), color: "#545454" })),
            react_1.default.createElement(react_native_1.Pressable, { style: [
                    styles_1.default.bottomButtonItem,
                    { bottom: (0, scale_1.scale)(68) },
                    isLiked && { backgroundColor: '#3FA841', borderColor: '#3FA841' },
                ], onPress: onToggleLikeButton }, isLiked ? (react_1.default.createElement(IconLiked_1.default, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20), color: "#FEFEFE" })) : (react_1.default.createElement(IconLike_1.default, { width: (0, scale_1.scale)(20), height: (0, scale_1.scale)(20), color: "#000000" }))))),
        isLoading && react_1.default.createElement(skeletons_1.ArticleSkeleton, null),
        react_1.default.createElement(ModalConfirmDeleteArticle_1.default, { visible: limitModalVisible, onClose: () => setLimitModalVisible(false), showCancelBtn: false, title: '', content: "\u672C\u65E5\u306E\u95B2\u89A7\u53EF\u80FD\u6570\u306E\u4E0A\u9650\u306B\u9054\u3057\u307E\u3057\u305F\u3002\u3055\u3089\u306B\u591A\u304F\u306E\u77E5\u8B58\u3092\u5F97\u308B\u306B\u306F\u3001\u7121\u6599\u3067\u4F1A\u54E1\u767B\u9332\u3057\u3066\u304F\u3060\u3055\u3044\u3002", confirmLabel: '新規登録画面へ', onConfirm: () => {
                setLimitModalVisible(false);
                (0, rootNavigation_1.navigate)(Routes_1.default.AUTH_NAVIGATOR, {
                    screen: Routes_1.default.LOGIN
                });
            } })));
};
exports.default = DetailStoryScreen;
